import { render } from "./InvoiceHeader.vue?vue&type=template&id=03f83dda&scoped=true"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js"

import "./InvoiceHeader.vue?vue&type=style&index=0&id=03f83dda&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f83dda"]])

export default __exports__